import { useState, useEffect } from 'react';
import axios from 'axios';
import { AiOutlineClose } from 'react-icons/ai'
// import ReactLoading from 'react-loading';
import '../theme/core.css'
import { AboutViewText, ProfileAboutStyledH2, SmallContainer } from '../styledComponents/globalStyled'
import { getArt } from 'utils/requestsJSON';


export default function ArtPage() {
    // console.log(process.env.REACT_APP_API_URL)
    const [items, setItems] = useState([]);
    useEffect(() => {
        let data: any = getArt();
        setItems(data);
        // axios.get(`${process.env.REACT_APP_API_URL}art/`)
        //     .then(res => {
        //         const result = res.data;
        //         setItems(result);
        //     })
    }, []);

    const [model, setModel] = useState(false);
    const [tempImgSrc, setTempImgSrc] = useState('');
    const getImg = (imgsrc: any) => {
        setTempImgSrc(imgsrc);
        setModel(true);
    }
    return (
        <>

            <div className={model ? 'model open' : 'model'}>
                <img src={tempImgSrc} alt="" />
                <AiOutlineClose onClick={() => setModel(false)} />
            </div>
            <ProfileAboutStyledH2 id="Gallery">All Art & 3D model Projects</ProfileAboutStyledH2>
            <AboutViewText>
                Throughout my life, my passion for artistic expression has found a vibrant outlet in the realm of 3D modeling and digital art creation. Constantly fueled by an intrinsic desire for creativity, I have persistently pushed the boundaries of my skills in this dynamic field. My journey in 3D modeling is an ongoing exploration of artistic growth and innovation.
                <br />
                <br />
                <br />
                Engaging with various 3D software tools, I have embarked on a diverse array of projects, each a testament to my commitment to the craft. From intricate 3D models to visually captivating digital artworks, my creative endeavors reflect a continual evolution, driven by a fervent dedication to refining and expanding my artistic capabilities.
                <br />
                <br />
                <br />
                As I navigate through this artistic odyssey, the convergence of technical proficiency and creative vision remains at the core of my pursuits. Each project becomes a canvas for exploration, pushing the limits of what is possible and unveiling new dimensions of artistic expression. This lifelong dedication to the art of 3D modeling stands as a testament to my unwavering commitment to the ever-evolving world of digital creativity.
            </AboutViewText>
            {(items.length < 1) ?
                <SmallContainer>
                    <h3>loading Images....</h3>
                </SmallContainer> :
                <div className='art-gallery'>

                    {items.map((item: any, index) => {
                        return <div className='art-pics' key={index} onClick={() => getImg(item.src)}>
                            <img src={item.src} style={{ width: "100%" }} alt="" />
                        </div>
                    })}

                </div>}


        </>
    );
}
